import React from "react";
import Title from "components/Title";
import AddAge from "./AddAge";
const TableHeader = () => {
  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-between gx-mb-3"
      style={{ flexWrap: "wrap" }}
    >
      <Title title="age.title" />
      <AddAge />
    </div>
  );
};

export default TableHeader;
